import React, { useEffect, useState } from "react";
import { ProjectAPI, BlobAPI } from "../services/api";
import { useNavigate } from "react-router-dom";
import { useSession } from "../context/SessionContext";
import { Project } from "../types/project";

type ProjectWithImage = Project & {
  imageUrl?: string | null;
};

const BaevrProjects = () => {
  const [projects, setProjects] = useState<ProjectWithImage[]>([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const { setSessionNo } = useSession();

  const userName = localStorage.getItem("userName") || "User";

  useEffect(() => {
    const loadProjects = async () => {
      try {
        const data = await ProjectAPI.getAll();

        const projectsWithImages = await Promise.all(
          data.map(async (project: Project) => {
            try {
              const imageUrl = await BlobAPI.getImage(
                "Project",
                project.projectNo
              );

              return { ...project, imageUrl };
            } catch {
              return { ...project, imageUrl: null };
            }
          })
        );

        setProjects(projectsWithImages as ProjectWithImage[]);
      } catch (error) {
        console.error("Failed to load projects:", error);
      } finally {
        setLoading(false);
      }
    };

    void loadProjects();
  }, []);

 /*  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setSessionNo(null);
    navigate("/login?source=itemizerdesktop", { replace: true });
  }; */
 /*  const handleLogout = () => {
  localStorage.removeItem("baevrDesktopUserId");
  localStorage.removeItem("baevrDesktopProjectId");
  localStorage.removeItem("baevrDesktopProjectName");

  localStorage.clear();
  sessionStorage.clear();

  setSessionNo(null);

  navigate("/login?source=itemizerdesktop", {
    replace: true,
  });
};
 */
const handleLogout = () => {
  // Prevent automatic restoration after logout.
  sessionStorage.setItem("baevrDesktopLoggedOut", "true");

  // Clear saved project and user information.
  localStorage.removeItem("baevrDesktopUserId");
  localStorage.removeItem("baevrDesktopProjectId");
  localStorage.removeItem("baevrDesktopProjectName");

  localStorage.clear();
  setSessionNo(null);

  navigate("/login?source=itemizerdesktop", {
    replace: true,
  });
};
  const colors = [
    "from-slate-400 to-slate-600",
    "from-gray-400 to-gray-600",
    "from-zinc-400 to-zinc-600",
    "from-neutral-400 to-neutral-600",
  ];

  const getColor = (name: string) => {
    const index =
      name.split("").reduce((total, character) => total + character.charCodeAt(0), 0) %
      colors.length;

    return colors[index];
  };

  const groupedProjects = projects.reduce<
    Record<string, { companyName: string; projects: ProjectWithImage[] }>
  >((groups, project) => {
    const companyNo = String(project.companyNo);

    if (!groups[companyNo]) {
      groups[companyNo] = {
        companyName: project.companyName || "Company",
        projects: [],
      };
    }

    groups[companyNo].projects.push(project);
    return groups;
  }, {});

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 p-6"
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      <header className="mb-8 flex items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">
            Welcome, {userName}
          </h1>
          <p className="mt-1 text-gray-500">{projects.length} Projects</p>
        </div>

        <button
          type="button"
          onClick={handleLogout}
          className="rounded-lg bg-red-600 px-4 py-2 font-semibold text-white transition hover:bg-red-700"
        >
          Logout
        </button>
      </header>

      {loading ? (
        <p className="py-10 text-center text-gray-500">Loading projects...</p>
      ) : projects.length === 0 ? (
        <p className="py-10 text-center text-gray-400">No projects found</p>
      ) : (
        <div className="space-y-8">
          {Object.entries(groupedProjects).map(([companyNo, company]) => (
            <section key={companyNo}>
              <div className="mb-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  {company.companyName}
                </h2>
                <div className="mt-2 border-b border-gray-300" />
              </div>

              <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
                {company.projects.map((project) => {
                  const color = getColor(project.projectName);

                  return (
                    /* <div
                      key={project.projectNo}
                      className="group overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-md transition duration-200 hover:-translate-y-1 hover:border-blue-400 hover:shadow-xl"
                    > */
                     <div
  key={project.projectNo}
 /*  onClick={() =>
    navigate(`/baevr-wbs/${project.projectNo}`, {
      state: { projectName: project.projectName },
    })
  } */
 onClick={() => {
  const userNo = localStorage.getItem("userNo");

  if (!userNo) {
    navigate("/login?source=itemizerdesktop", {
      replace: true,
    });
    return;
  }

  localStorage.setItem("baevrDesktopUserId", userNo);
  localStorage.setItem(
    "baevrDesktopProjectId",
    String(project.projectNo)
  );
  localStorage.setItem(
    "baevrDesktopProjectName",
    project.projectName
  );

  navigate(`/baevr-wbs/${project.projectNo}`, {
    state: { projectName: project.projectName },
  });
}}
  className="group cursor-pointer overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-md transition duration-200 hover:-translate-y-1 hover:border-blue-400 hover:shadow-xl"
>
                      {project.imageUrl ? (
                        <div className="relative overflow-hidden">
                          <img
                            src={project.imageUrl}
                            className="aspect-video w-full object-cover transition-transform duration-300 group-hover:scale-105"
                            alt={project.projectName}
                          />
                        </div>
                      ) : (
                        <div
                          className={`flex aspect-video w-full flex-col justify-end bg-gradient-to-br ${color} p-4`}
                        >
                          <h3 className="truncate text-white">
                            {project.projectName}
                          </h3>
                          <p className="text-white/70">Project</p>
                        </div>
                      )}

                      <div className="space-y-1 bg-gray-50 p-3">
                        <h3 className="truncate font-medium text-gray-800">
                          {project.projectName}
                        </h3>
                        {project.startDate && (
                          <p className="text-gray-500">
                            {new Date(project.startDate).toLocaleDateString()}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};

export default BaevrProjects;
